// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import firebase from 'firebase/app'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue)

Vue.config.productionTip = false

const hostname = location.hostname
// Your web app's Firebase configuration
var config

// ホスト名で読みに行くDBを変更する
switch (hostname) {
  case 'staging-zj.firebaseapp.com':
  case 'staging-zj.web.app':
    console.log('run dev/staging')
    config = {
      apiKey: 'AIzaSyCQ4nj7h_4gd5V1sOvObkDGnta7xo3rIW4',
      authDomain: 'staging-zj.firebaseapp.com',
      databaseURL: 'https://staging-zj.firebaseio.com',
      projectId: 'staging-zj',
      storageBucket: 'staging-zj.appspot.com',
      messagingSenderId: '110326709896',
      appId: '1:110326709896:web:eba6c4bd901b3238a1e93d'
    }
    break
  case 'localhost':
  case 'zekkenjockey.firebaseapp.com':
  case 'zekkenjockey.web.app':
    console.log('run production')
    config = {
      apiKey: 'AIzaSyC6zh9UIwAzf1JHCemT0GjB3oRmW3UdPdA',
      authDomain: 'zekkenjockey.firebaseapp.com',
      databaseURL: 'https://zekkenjockey.firebaseio.com',
      projectId: 'zekkenjockey',
      storageBucket: 'zekkenjockey.appspot.com',
      messagingSenderId: '446133948254',
      appId: '1:446133948254:web:f717cbc251c06827e489cf'
    }
    break
}

firebase.initializeApp(config)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/index.js